import React , { useState } from "react";
import "./Home.css";
import { Button } from "primereact/button";
import first from "../../Images/Features/Boost Efficiency.png";
import second from "../../Images/Features/Centralized Info Hub.png";
import third from "../../Images/Features/reshot-icon-responsive-design-EWQ2ZPK3GN.svg";
import forth from "../../Images/Features/reshot-icon-smartphone-42GN73QJUD.svg";
import fifth from "../../Images/Features/Comprehensive HR Tools.png";
import sixth from "../../Images/Features/reshot-icon-protection-GDY5X3BCH7.svg";
import seventh from "../../Images/Features/reshot-icon-24-7-support-NWUJ4FHEGT.svg";
import eirth from "../../Images/Features/reshot-icon-scalability-THK95RAYUZ.svg";
import ninth from "../../Images/Features/reshot-icon-problem-solve-AG43HY2SFP.svg";
import tenth from "../../Images/Features/reshot-icon-improvement-changes-PKDL5F48G9.svg";
import Register from "../Register"
import { Dialog } from "primereact/dialog";
import { Helmet } from "react-helmet";
import { scroller } from "react-scroll";

function Home() {
   const [openRegister, setOpenRegister] = useState(false);

  return (

    <>
<Helmet>
      {/* Page Title */}
      <title>Transform HR Management with HelloEMS | Clota Technology</title>

      {/* Meta Description */}
      <meta
        name="description"
        content="HelloEMS is a comprehensive HR solution covering Attendance, Payroll, Employee Lifecycle, and more—accessible anytime, anywhere."
      />

      {/* Meta Keywords */}
      <meta
        name="keywords"
        content="HR software, Employee Management System, HelloEMS, leave records,
         Payroll Software, Leave Management, Attendance Tracker, HR, Geolocation Based Attendance, 

Accurate Tracking Of Working Hours, 

Easily Configurable,

Payroll Integration,  
Entire Organization Hirarchy, 

Reporting Hierarchy,

Pleasing GUI Of Reporting Herarchy, 
         Shift Planning, HR automation, HelloEMS, Clota Technology"
      />

      {/* Open Graph Meta Tags (Facebook, LinkedIn) */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://helloems.com/" />
      <meta property="og:title" content="Transform HR Management with HelloEMS" />
      <meta
        property="og:description"
        content="Simplify HR operations with HelloEMS—Attendance, Payroll, Leave, Employee Lifecycle, and more. Designed for startups to enterprises."
      />
      <meta property="og:image" content="/logo512.png" />

      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content="https://helloems.com/" />
      <meta name="twitter:title" content="Transform HR Management with HelloEMS" />
      <meta
        name="twitter:description"
        content="HelloEMS brings you a centralized, mobile-ready HR suite with Attendance, 
        Payroll, Leaves, and more. Perfect for small and growing businesses.
        "
      />
      <meta name="twitter:image" content="/logo512.png" />

      {/* Icons and Manifest */}
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />
    </Helmet>

    <div className="home-section">
      <div className="home-content-subsection">
        <div className="home-heading">
          Transform HR Management with HelloEMS
          <br />
          Anytime, Anywhere
            </div>
        <div className="home-para">
          HelloEMS a comprehensive Employee Management System designed to streamline HR processes.
        </div>
        <Button 
  label="Book Free Demo"
  onClick={() => {
    scroller.scrollTo("ContactUs", {
      duration: 500,
      delay: 0,
      smooth: "easeInOutQuart",
      // offset: -100 
    });
  }}
/>
         
    </div>

      <div className="image-section"></div>
      <div className="home-features-subsection">
        <h2 className="sub-heading">Why HelloEMS?</h2>
        <div className="features-points">
          <img src={first} alt="" />

          <p>
            <span className="bold-text">Centralized Info Hub : </span>
          Consolidate all employee data—docs, leave records, paychecks, and attendance—in one platform.
          </p>
          <img src={third} alt="" />
          <p>
            <span className="bold-text"> User-Friendly Interface: </span>
            Access our intuitive platform from any device, anywhere.
          </p>
          <img src={forth} alt="" />
          <p>
            <span className="bold-text"> Mobile-Friendly: </span>
            Full functionality on mobile devices without a dedicated app
          </p>
          <img src={fifth} alt="" />

          <p>
            <span className="bold-text"> Comprehensive HR Tools: </span>
            Simplify onboarding, performance management, and compliance
            tracking.
          </p>
          <img src={second} alt="" />

          <p>
            <span className="bold-text"> Boost Efficiency: </span>
            Reduce admin tasks, freeing HR for strategic work.
          </p>
          <img src={sixth} alt="" />

          <p>
            <span className="bold-text"> Data Security: </span>
            Protect employee data with top-notch security measures.
          </p>
          <img src={eirth} alt="" />

          <p>
            <span className="bold-text"> Customizable & Scalable:</span>
            Tailor Hello EMS to your needs and scale as you grow.
          </p>
          <img src={ninth} alt="" />

          <p>
            <span className="bold-text">Seamless Integration: </span>
            Integrate with payroll, accounting, and other systems.
          </p>
          <img src={tenth} alt="" />

          <p>
            <span className="bold-text"> Continuous Improvement: </span>
            Enjoy regular updates based on feedback and best practices.
          </p>
          <img src={seventh} alt="" />
          <p>
            <span className="bold-text">Support & Training: </span>
            Access robust support and training resources.
          </p>
        </div>
      </div>
    </div>

    </>
  );
}

export default Home;
